// 六合子菜单玩法配置
export const LH_SUB_TAB_CONFIG = {
  '特码': ['特码A', '特码B'],
  '正码': ['正码A','正码B'],
  '正特': ['正1特', '正2特', '正3特', '正4特', '正5特', '正6特'],
  '特肖首尾': [],
  '一肖尾数': ['一肖中', '一肖不中', '尾数中', '尾数不中'],
  //'一肖尾数': ['一肖中', '一肖不中'],
  '连肖': ['二肖连中', '三肖连中', '四肖连中', '五肖连中', '二肖连不中', '三肖连不中', '四肖连不中', '五肖连不中'],
  '连尾': ['二尾连中', '三尾连中', '四尾连中', '五尾连中', '二尾连不中', '三尾连不中', '四尾连不中', '五尾连不中'],
  '连码': ['三全中', '三中二', '三中二X','二全中', '二中特','二中特X', '特串'],
  '自选不中': ['五不中', '六不中', '七不中', '八不中', '九不中', '十不中', '十一不中', '十二不中'],
  '总肖': [],
  '合肖': ['二肖', '三肖', '四肖', '五肖', '六肖'],
  '特平中': ['一粒任中', '二粒任中', '三粒任中', '四粒任中', '五粒任中'],
  '中一': ['四中一', '五中一', '六中一', '七中一', '八中一', '九中一', '十中一'],
  '半波': [],
  '五行': [],
};

export const getTabItem = (subId) => {
  let DEFAULT_TAB = [];
  Object.keys(LH_SUB_TAB_CONFIG).forEach((key, index) => {
    if (subId === index + 1) {
      DEFAULT_TAB = LH_SUB_TAB_CONFIG[key];
    }
  });
  return DEFAULT_TAB;
};



// WEBPACK FOOTER //
// ./src/utils/lhConfig.js